import { usePaginatedMasterData } from './usePaginatedMasterData';
import { getShifts } from '../services/shiftService';
import type { ShiftListFilters, ShiftListItem } from '../types/shift';
import { activeConfigurationFilters } from '../utils/configurationFilters';

const EMPTY_FILTERS: ShiftListFilters = activeConfigurationFilters();

export function useShifts() {
  return usePaginatedMasterData<ShiftListItem, ShiftListFilters>({
    getId: item => item.shiftId,
    initialFilters: EMPTY_FILTERS,
    errorMessage: 'Unable to load shifts.',
    loadPage: async ({ page, pageSize, search, filters }) =>
      getShifts({
        page,
        pageSize,
        filters: {
          ...filters,
          search: search || undefined,
        },
      }),
  });
}
